import React from 'react';
import {Grid, Typography, TextField, GridProps} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import FormikPassphrase from 'components/inputs/FormikPassphrase';

const useEntryStyles = makeStyles({
   name: {
      textAlign: 'right',
      minWidth: ({nameMinWidth}: {nameMinWidth?: string}) => nameMinWidth || 'auto',
   },
   value: {
      margin: 0,
      '& .MuiInputBase-root.Mui-disabled': {
         color: 'inherit',
      },
   },
});

type Props = {
   name?: React.ReactNode;
   value: React.ReactNode;
   justify?: GridProps['justifyContent'];
   nameWidth?: GridProps['xs'];
   nameMinWidth?: string;
   alignItems?: GridProps['alignItems'];
   autoFocus?: boolean;

   formName?: string;
   password?: boolean;
   fetchUrl?: string;
};
export const Entry = ({
   name,
   value,
   alignItems = 'center',
   justify = 'center',
   nameWidth = true,
   nameMinWidth,
   autoFocus,

   formName,
   password,
   fetchUrl,
}: Props) => {
   const classes = useEntryStyles({nameMinWidth});
   return (
      <Grid
         item
         container
         spacing={2}
         alignItems={alignItems}
         justifyContent={justify}
         wrap={'nowrap'}
      >
         <Grid className={classes.name} item xs={nameWidth}>
            {name ? <Typography>{name}</Typography> : null}
         </Grid>
         <Grid item xs>
            {React.isValidElement(value) ? (
               value
            ) : password ? (
               <FormikPassphrase
                  name={formName!}
                  autoFocus={autoFocus}
                  className={classes.value}
                  disabled
                  fullWidth
                  defaultValue={value}
                  variant="outlined"
                  fetchUrl={fetchUrl}
               />
            ) : (
               <TextField
                  autoFocus={autoFocus}
                  className={classes.value}
                  disabled
                  fullWidth
                  defaultValue={value}
                  variant="outlined"
               />
            )}
         </Grid>
      </Grid>
   );
};
